import React from 'react';
import styled from 'styled-components';

import { PBB_INCENTIVES_TERMS_URL } from 'src/payments/constants';
import { BankOutlineIcon } from 'src/assets/bank-outline-icon';
import { CoinDepositIcon } from 'src/assets/coin-deposit-icon';
import { PhoneBankIcon } from 'src/assets/phone-bank-icon';
import {
  StepsList,
  Step,
  StepContent,
} from 'src/payments/components/incentive-accordion-styles/incentive-accordion-styles';
import { Typography } from 'src/typography';

export const bankStatementTerms = (value: number, minimumOrderTotalDisplay: string): string =>
  `Your bank statement will show your order charge and a separate $${value} deposit. ` +
  `Valid only on your first Pay by Bank order of ${minimumOrderTotalDisplay} or more. ` +
  `If your first Pay by Bank order does not meet the minimum, later orders do not qualify. ` +
  `Eligibility requirements apply.`;

type CashBackDetailsProps = {
  paymentStepText?: string;
  value: number;
  minimumOrderTotalDisplay: string;
};

export const CashBackDetails = ({
  paymentStepText = 'Pay at checkout with your bank',
  value,
  minimumOrderTotalDisplay,
}: CashBackDetailsProps): JSX.Element => (
  <div>
    <StepsList>
      <Step>
        <BankOutlineIcon />
        <StepContent>1. Link your bank</StepContent>
      </Step>
      <Step>
        <PhoneBankIcon />
        <StepContent>2. {paymentStepText}</StepContent>
      </Step>
      <Step>
        <CoinDepositIcon />
        <StepContent>3. Get ${value} back in your bank.</StepContent>
      </Step>
    </StepsList>
    <Terms size='small'>
      {bankStatementTerms(value, minimumOrderTotalDisplay)}
      <br />
      <CashBackTermsLink>View full terms</CashBackTermsLink>
    </Terms>
  </div>
);

export const CashBackTermsLink = styled.a.attrs({
  href: PBB_INCENTIVES_TERMS_URL,
  target: '_blank',
  rel: 'noreferrer',
})``;

const Terms = styled(Typography.Label)`
  margin-top: ${({ theme }) => theme.spaces[4]};
`;
